import { apiService } from '@/services/APIService';

const PATH = '/user-duplicates';

export default {
  getUserDuplicates(params) {
    return apiService.get(PATH, params);
  },
  getUserDuplicate(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },
  noDuplicate(id, payload) {
    return apiService.post(`${PATH}/${id}/no-duplicate`, payload);
  },
  initiateEmail(id, payload) {
    return apiService.post(`${PATH}/${id}/initiate-email`, payload);
  },
  initiateVk(id, payload) {
    return apiService.post(`${PATH}/${id}/initiate-vk`, payload);
  },
  initiateTelegram(id, payload) {
    return apiService.post(`${PATH}/${id}/initiate-telegram`, payload);
  },
  initiateApple(id, payload) {
    return apiService.post(`${PATH}/${id}/initiate-apple`, payload);
  },
  confirmMerge(id, payload) {
    return apiService.post(`${PATH}/${id}/confirm`, payload);
  },
  resendEmailCode(id, payload) {
    return apiService.post(`${PATH}/${id}/resend-code`, payload);
  },
};
